import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { validateRequiredString } from '@utriper/core';
import { alpha, Box, Button, Typography } from '@mui/material';
import { LoadingIndicator, TextInput } from '@utriper/core-ui';
import { Container, Label } from 'modules/Checkin/styles';
import BookingCodeHelper from '../BookingCodeHelper';

const AuthForm = ({ initialValues, onSubmit = () => {}, loading = false }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`checkin.auth_form.${key}`);
    const [openBookingCodeHelper, setOpenBookingCodeHelper] = useState(false);

    const handleSubmit = (values) => {
        return onSubmit(values);
    };

    const validateForm = (values) => {
        const errors = {};

        if (!validateRequiredString(values?.lastName)) {
            errors.lastName = translate('validations.last_name_required');
        }

        if (!validateRequiredString(values?.bookingCode)) {
            errors.bookingCode = translate('validations.booking_code_required');
        }

        return errors;
    };

    return (
        <Form
            onSubmit={handleSubmit}
            validate={validateForm}
            initialValues={{ ...initialValues }}
            render={({ handleSubmit }) => (
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    sx={{
                        width: '100%',
                        maxWidth: '480px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                        mx: 'auto',
                        px: 3,
                        boxSizing: 'border-box',
                    }}>
                    <Typography variant="h4" component="h1" fontSize={20} fontWeight={900} sx={{ color: '#131313' }}>
                        {t('checkin.title')}
                    </Typography>

                    <Container mt={2}>
                        <Label>{translate('last_name_label')}</Label>
                        <Field id="lastName" name="lastName" component={TextInput} placeholder={translate('last_name_placeholder')} />
                    </Container>

                    <Container>
                        <Label>{translate('booking_code_label')}</Label>
                        <Field id="bookingCode" name="bookingCode" component={TextInput} placeholder={translate('booking_code_placeholder')} />
                        <Button
                            sx={{
                                width: '100%',
                                justifyContent: 'flex-end',
                                color: alpha('#131313', 0.75),
                                fontSize: '14px',
                                fontWeight: 600,
                                textTransform: 'none',
                                p: 0,
                                minWidth: 0,
                                textDecoration: 'underline',
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                    textDecoration: 'underline',
                                },
                                '&:active': {
                                    backgroundColor: 'transparent',
                                    textDecoration: 'underline',
                                },
                                '&:focus': {
                                    backgroundColor: 'transparent',
                                    textDecoration: 'underline',
                                },
                            }}
                            variant="text"
                            component="button"
                            onClick={() => setOpenBookingCodeHelper(true)}>
                            {translate('booking_code_helper')}
                        </Button>
                    </Container>

                    <Button
                        sx={{
                            backgroundColor: '#137DC5',
                            width: '100%',
                            color: 'white',
                            textTransform: 'none',
                            fontWeight: 700,
                            py: 1,
                        }}
                        type="submit"
                        variant="contained"
                        onClick={(e) => handleSubmit(e)}
                        disabled={loading}
                        loading={loading}
                        loadingIndicator={<LoadingIndicator />}>
                        {translate('submit_button')}
                    </Button>

                    <BookingCodeHelper open={openBookingCodeHelper} onClose={() => setOpenBookingCodeHelper(false)} />
                </Box>
            )}
        />
    );
};

export default AuthForm;
